<template>
    <b-modal
      v-model="visible"
      title="Skapa rapport"
      @hidden="onModalClose"
      :no-close-on-backdrop="isLoading"
      :no-close-on-esc="isLoading"
      :hide-header-close="isLoading"
    >
      <div
        v-if="isLoading"
        class="d-flex justify-content-center align-items-center p-3"
        style="height: 100px;"
      >
        <Spinner
          style="width: 30px; height: 30px; color: #007bff; vertical-align: middle;"
        ></Spinner>
        <p class="ml-2 align-self-center">Schemalägg rapport</p>
      </div>
  
      <div v-else>
        <p>
          Resultatet kan ta tid att skapa, vill du schemalägga körningen och få ett mail när du kan ladda ner körningen?
        </p>
  
        <!-- Add Report Name Input -->
        <b-form-group
          label="Rapportnamn (max 100 tecken)"
          label-for="report-name-input"
        >
          <b-form-input
            id="report-name-input"
            v-model="reportName"
            :disabled="isLoading"
            maxlength="100"
            placeholder="Ange rapportnamn"
          ></b-form-input>
          <small v-if="reportName.length > 0">
            {{ 100 - reportName.length }} tecken kvar
          </small>
        </b-form-group>
      </div>
  
      <template #modal-footer>
        <b-button :disabled="isLoading || !reportName" variant="success" @click="submit"
          >Schemalägg körning</b-button
        >
        <b-button :disabled="isLoading" variant="danger" @click="cancel"
          >Avbryt</b-button
        >
      </template>
    </b-modal>
  </template>
  
  <script>
  import Spinner from "@/components/Shared/Spinner/Spinner";
  export default {
    name: "ScheduleReportModal",
    components: { Spinner },
    props: {
      loading: { type: Boolean, required: false },
      show: {
        type: Boolean,
        required: true
      }
    },
    watch: {
      show(newVal) {
        this.visible = newVal;
        this.reportName = ''
      },
      loading(newVal) {
        this.isLoading = newVal;
      }
    },
    data() {
      return {
        isLoading: this.loading,
        visible: this.show,
        reportName: '' // Add this to track the report name
      };
    },
    methods: {
      submit() {
        this.$emit("submit", this.reportName); // Pass the report name when submitting
      },
      cancel() {
        this.$emit("cancel");
      },
      onModalClose() {
        this.$emit("cancel");
      }
    }
  };
  </script>
  